document.addEventListener('variant:change', (event) => {
  const variant = event.detail.variant;
  if (!variant || !variant.featured_media) return;

  const gallery = document.querySelector('product-gallery');
  if (!gallery) return;

  const featuredMediaId = variant.featured_media.id;

  const mediaElements = Array.from(gallery.querySelectorAll('[data-media-id]'));

  let show = false;

  mediaElements.forEach((media) => {
    const mediaId = parseInt(media.dataset.mediaId);

    // start showing from selected variant featured media
    if (mediaId === featuredMediaId) {
      show = true;
    }

    // stop when next variant featured media is encountered
    const isAnotherVariantStart =
      mediaId !== featuredMediaId &&
      media.hasAttribute('data-variant-media');

    if (isAnotherVariantStart && show) {
      show = false;
    }

    media.style.display = show ? '' : 'none';
  });
});
